const BaseElement = require('./element.base')

const ButtonfieldElement = BaseElement.extend({

    validateConstructor(attrs) {
        if (! attrs.input || ! attrs.button) {
            throw new Error('Buttonfield Element requires an input and a button.')
        }

        // inline require to allow circular dependency
        const Element = require('./element')

        // ensure that `input` and `button` are Element models
        if (! (attrs.input instanceof BaseElement)) {
            attrs.input = new Element(attrs.input)
        }
        if (! (attrs.button instanceof BaseElement)) {
            attrs.button = new Element(attrs.button)
        }

        return attrs
    },

    initializeElement() {
        const input = this.get('input')

        // set the input value to buttonfield's value
        input.set('value', this.get('value'))

        // update input value when buttonfield value changes
        this.on('change:value', (model, value, options) => {
            input.set('value', value)
        })

        // update buttonfield value with input value changes
        this.listenTo(input, 'change:value', (model, value, options) => {
            this.set('value', value)
        })
    },

})

module.exports = ButtonfieldElement
